import { Box, Skeleton, Stack } from '@mui/material'

import rem from '~/utils/ui'

export default function OFUSimulateStepLoading() {
  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      gap={1}
      sx={{ width: '100%' }}
    >
      <Box>
        <Skeleton variant="circular" width={40} height={40} />
      </Box>
      <Stack gap={1} sx={{ width: '100%' }}>
        <Skeleton variant="text" width={150} height={20} />
        <Skeleton variant="text" width={200} height={20} />
        <Skeleton
          variant="rounded"
          width="100%"
          sx={{ width: '100%', height: rem(200) }}
        />
      </Stack>
    </Stack>
  )
}
